module.exports = __webpack_public_path__ + "static/media/fail.f2bf6b5c.mp3";